import { Badge, Header } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';

import { type TopicType } from './types';

type TopicFiltersProps = {
  readonly allTopics: TopicType[];
  readonly selectedTopicCodes: string[];
  readonly toggleTopic: (topicCode: string) => void;
};

const TopicFilters = ({ allTopics, selectedTopicCodes, toggleTopic }: TopicFiltersProps) => {
  const { t } = useTranslation();
  return (
    <section className="mt-4">
      <Header level="h2">{t('page.healthLibrary.filterTitle')}</Header>
      <div className="mt-2 flex flex-wrap gap-2">
        {allTopics.map((topic) => {
          const selected = selectedTopicCodes.includes(topic.code);

          return (
            <Badge
              appearance={selected ? 'primary' : 'secondary'}
              className="cursor-pointer text-sm"
              key={topic.code}
              onClick={() => toggleTopic(topic.code)}
            >
              {topic.title}
            </Badge>
          );
        })}
      </div>
    </section>
  );
};

export { TopicFilters };
